export enum FuelType {
  Diesel = 1,
  Petrol = 2
}